import { render, staticRenderFns } from "./UsuarioVeraz.vue?vue&type=template&id=21172e20&"
import script from "./UsuarioVeraz.vue?vue&type=script&lang=js&"
export * from "./UsuarioVeraz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports